import {combineReducers} from "redux";
import resource from "features/pages/payment/reducer";
import invoice from "./invoice/reducer";
import cards from "./cards/reducer";
import pay from "./pay/reducer";

export default combineReducers({
    resource,
    invoice,
    cards,
    pay
});